import React, { useEffect, useState } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { EmotionSection } from '../components/EmotionSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { HowItWorks } from '../components/HowItWorks';
import { BeforeAfterSection } from '../components/BeforeAfterSection';
import { TestimonialCarousel } from '../components/TestimonialCarousel';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { ConsultationModal } from '../components/ConsultationModal';
import { StickyCallBar } from '../components/StickyCallBar';
import { captureAttribution } from '../utils/attribution';
export function LandingPage() {
  const [showForm, setShowForm] = useState(false);
  const openForm = () => setShowForm(true);
  useEffect(() => {
    captureAttribution();
  }, []);
  return <div className="min-h-screen bg-background flex flex-col font-sans text-foreground pb-14" data-id="element-152">
      <Header onBookConsultation={openForm} data-id="element-153" />
      <main className="flex-grow" data-id="element-154">
        <HeroSection onBookConsultation={openForm} data-id="element-155" />
        <BeforeAfterSection onBookConsultation={openForm} data-id="element-156" />
        <EmotionSection data-id="element-157" />
        <DifferenceSection data-id="element-158" />
        <HowItWorks data-id="element-159" />
        <TestimonialCarousel data-id="element-160" />
        <FAQSection data-id="element-161" />
        <FinalCTA onBookConsultation={openForm} data-id="element-162" />
      </main>
      <Footer data-id="element-163" />
      <ConsultationModal isOpen={showForm} onClose={() => setShowForm(false)} data-id="element-164" />
      <StickyCallBar data-id="element-165" />
    </div>;
}